// extracted by mini-css-extract-plugin
export var root = "index-module--root--hKTZS";
export var navContainer = "index-module--navContainer--uWfqU";
export var blogsContainer = "index-module--blogsContainer--3S+Ok";
export var loadMoreContainer = "index-module--loadMoreContainer--sBg7Q";